import { ReviewsViewModel, UserReviewViewModel } from 'models/hotel';
import { mapUserReview } from './user-review-adapter';
import { Reviews } from '__generated__/api';
import ReviewInfo = Reviews.ReviewInfo;

export const mapReviews = (currentStore: ReviewsViewModel, response: ReviewInfo, totalRequested?: number): ReviewsViewModel => {
  const userReviews: UserReviewViewModel[] = response.reviews.map(mapUserReview);

  const {
    totalCount,
    reviewCountLocalized,
    averageOverallRating,
    cleanliness,
    cleanlinessOverMax,
    serviceAndStaff,
    amenityScore,
    hotelCondition,
    superlative,
    cleanlinessPercent,
    serviceAndStaffPercent,
    serviceAndStaffOverMax,
    amenityScorePercent,
    amenityScoreOverMax,
    hotelConditionPercent,
    hotelConditionOverMax,
    lastIndex,
    ratingCounts,
    reviewDisclaimer
  } = response.summary;

  currentStore.count = totalCount.raw;
  currentStore.localizedCount = totalCount.formatted;
  currentStore.localizedCountWithLabel = reviewCountLocalized;

  currentStore.overallRating = averageOverallRating.raw;
  currentStore.localizedOverallRating = averageOverallRating.formatted;

  currentStore.cleanliness = cleanliness.raw;
  currentStore.cleanlinessPercent = cleanlinessPercent;
  currentStore.localizedCleanliness = cleanliness.formatted;
  currentStore.cleanlinessOverMax = cleanlinessOverMax;

  currentStore.serviceAndStaff = serviceAndStaff.raw;
  currentStore.serviceAndStaffPercent = serviceAndStaffPercent;
  currentStore.localizedServiceAndStaff = serviceAndStaff.formatted;
  currentStore.serviceAndStaffOverMax = serviceAndStaffOverMax;

  currentStore.amenityScore = amenityScore.raw;
  currentStore.amenityScorePercent = amenityScorePercent;
  currentStore.localizedAmenityScore = amenityScore.formatted;
  currentStore.amenityScoreOverMax = amenityScoreOverMax;

  currentStore.hotelCondition = hotelCondition.raw;
  currentStore.hotelConditionPercent = hotelConditionPercent;
  currentStore.localizedHotelCondition = hotelCondition.formatted;
  currentStore.hotelConditionOverMax = hotelConditionOverMax;

  currentStore.superlative = superlative;

  currentStore.lastIndex = lastIndex;

  currentStore.ratingCounts = ratingCounts;

  if (!currentStore.userReviews) {
    currentStore.userReviews = [];
  }

  currentStore.userReviews.push(...userReviews);
  currentStore.totalReviewsRequested = totalRequested;
  currentStore.reviewDisclaimer = reviewDisclaimer;

  return currentStore;
};
